module.exports = __webpack_public_path__ + "img/2.737f6685.webp";